import StarryNightForest from "assets/starry-night-forest.jpg";
import Empty from "./EmptyPageContent";

interface UnfoundResourceProps {
  resourceId?: string;
  resourceName?: string;
}

export default function UnknownError({ resourceId = undefined, resourceName = undefined }: UnfoundResourceProps) {
  const returnText = "Hmm... Seems like we had an issue trying to find the way forward....";
  let body = "";
  if (resourceId) {
    body += resourceName
      ? `We had an unidentified error while accessing the ${resourceName} with the id ${resourceId}`
      : `We had an unidentified error while accessing the id ${resourceId}`;
  } else {
    body = "We experienced an unidentified error.";
  }
  return <Empty heading={returnText} {...(body ? { body } : {})} image={{ src: StarryNightForest, alt: "Path to nowhere..." }} />;
}
